import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const appointmentNotesSlice = createSlice({
    name: 'appointmentNotes',
    initialState,
    reducers: {
        setAppointmentNotes: (state, action) => {
            return action.payload;
        },
        removeAppointmentNotes: () => {
            return initialState;
        },
    },
});

export const { setAppointmentNotes, removeAppointmentNotes } = appointmentNotesSlice.actions;
export default appointmentNotesSlice.reducer;